export default {
      id: "icon-emoji-happy-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-emoji-happy",
      toString: function () {
        return this.url;
      }
    }